/*
 * Public API Surface of ng-loading-indicator
 */

export * from './lib/services/loading-indicator.service';
export * from './lib/components/loading-indicator.component';
export * from './lib/ng-loading-indicator.module';
